import { Teams } from './pages/Teams'
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import {Login} from './pages/Login';
import {Register} from './pages/Register';
import {User} from './models/User';
import {useEffect, useState} from "react";
import {UserService} from './services/UserService';
import {EmployeeDashboard} from "./pages/EmployeeDashboard";
import {Toaster} from "sonner";
import {Header} from "./components/Header";
import {UserProfile} from "./pages/UserProfile";
import {ManagerDashboard} from "./pages/ManagerDashboard";
import { Reports } from './pages/Reports';
import AdminDashboard from "./pages/AdminDashboard";

function App() {
    const [currentUser, setCurrentUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUser = async () => {
            if (localStorage.getItem('token') == null) {
                setCurrentUser(null)
                setLoading(false);
            } else {
                try {
                    const user = await UserService.getCurrentUser();
                    setCurrentUser(user);
                    setLoading(false);
                } catch (error) {
                    setCurrentUser(null);
                    localStorage.removeItem('token');
                    setLoading(false);
                    return;
                }
            }
        };
        fetchUser();
    }, []);


    const handleLogin = (user: User) => {
        setCurrentUser(user);
    };

    const handleLogout = () => {
        UserService.logout();
        setCurrentUser(null);
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>
        );
    }

    return (
        <BrowserRouter>
            <div className="min-h-screen flex flex-col">
                <Toaster position="top-right"/>

                {currentUser && <Header user={currentUser} onLogout={handleLogout}/>}

                <main className="flex-1">
                    <Routes>
                        <Route
                            path="/"
                            element={
                                currentUser ? <Navigate to="/dashboard" replace/> : <Navigate to="/login" replace/>
                            }
                        />

                        <Route
                            path="/login"
                            element={
                                currentUser ? <Navigate to="/dashboard" replace/> : <Login onLogin={handleLogin}/>
                            }
                        />

                        <Route
                            path="/register"
                            element={
                               <Register/>
                            }
                        />

                        <Route
                            path="/dashboard"
                            element={
                                currentUser ? (
                                    <div className="container py-8 px-12">
                                        {currentUser.role === 'EMPLOYEE' ? (
                                            <EmployeeDashboard user={currentUser}/>
                                        ) : (
                                            <ManagerDashboard user={currentUser}/>
                                        )}
                                    </div>
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />

                        <Route
                            path="/profile"
                            element={
                                currentUser ? (
                                    <UserProfile user={currentUser} onLogout={handleLogout} />
                                ) : (
                                    <Navigate to="/login" replace/>
                                )
                            }
                        />


                        <Route
                            path="/teams"
                            element={
                                currentUser ? (
                                    currentUser.role === 'MANAGER' || currentUser.role === 'ADMIN' ? (
                                        <div className="container py-8 px-12">
                                            <Teams user={currentUser} />
                                        </div>
                                    ) : (
                                        <Navigate to="/dashboard" replace />
                                    )
                                ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                        />

                        <Route
                            path="/admin"
                            element={
                                currentUser ? (
                                    currentUser.role === 'ADMIN' ? (
                                        <div className="container py-8 px-12">
                                            <AdminDashboard user={currentUser} />
                                        </div>
                                    ) : (
                                        <Navigate to="/dashboard" replace />
                                    )
                                ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                        />

                        <Route
                        path='/report/:teamId'
                        element={
                            currentUser ? (
                                currentUser.role === 'MANAGER' || currentUser.role === 'ADMIN' ? (
                                    <div className="container py-8 px-12">
                                        <Reports user={currentUser} />
                                    </div>
                                ) : (
                                    <p>...</p>
                                )
                            ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                            />

                        <Route
                            path="/report"
                            element={
                                currentUser ? (
                                    currentUser.role === 'MANAGER' || currentUser.role === 'ADMIN' ? (
                                        <div className="container py-8 px-12">
                                            <Reports user={currentUser} />
                                        </div>
                                    ) : (
                                        <Navigate to="/dashboard" replace />
                                    )
                                ) : (
                                    <Navigate to="/login" replace />
                                )
                            }
                        />

                        {/* /reports listing removed - teams link routes to team cards which contain report links */}
                    </Routes>
                </main>
            </div>
        </BrowserRouter>
    );
}

export default App;
